import {
  GET_DEPENDENT_BUYER,
  GET_DEPENDENT_BUYER_ERROR,
  GET_DEPENDENT_BUYER_SUCCESS
} from './DependentBuyerSection.actions'

const dependentBuyerState = {
  error: undefined,
  loading: true,
  dni: '',
  dependentBuyer: []
}

/**
 * The Dependent Buyer Section reducer.
 */
const dependentBuyerReducer = (state = dependentBuyerState, { payload, type }) => {
  switch (type) {
    case GET_DEPENDENT_BUYER:
      return { ...state, loading: true }
    case GET_DEPENDENT_BUYER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        dependentBuyer: payload.buyer
      }
    case GET_DEPENDENT_BUYER_ERROR:
      return { ...state, error: payload.error, loading: false }
    default:
      return state
  }
}

export default dependentBuyerReducer
